const ExerciseHeader = ({ title }) => (
  <div className="bg-gradient-to-r from-red-400 to-red-300 text-white px-3 sm:px-6 py-2 sm:py-3 rounded-full inline-block mb-3 sm:mb-5 text-sm sm:text-lg font-bold text-right">
    {title}
  </div>
);

export default ExerciseHeader